import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { path } from 'ramda'
import { breakpoints } from '@/styles'
import getLabels from '@/features/Profile/EmploymentInfo/labels'
import { DocumentView, ValueText, DocumentStatusComponent } from '@/features/Application/elements'
import { InformationTable } from '@/features/Application/elements/tables'
import useFinancialFiles from '@/hooks/use-financial-files'
import useRole from '@/hooks/use-role'
import useMediaQuery from '@/hooks/use-media-query'

const DocumentsView = ({ application, isLocked, isLoading, applicationLoading }) => {
  const { t } = useTranslation()
  const userRole = useRole()
  const userId = application?.user_id
  const userFiles = userId ? application?.users?.[userId]?.files?.user_secure_files : undefined
  const secureFiles = useFinancialFiles(userFiles, userRole)

  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  const LABELS = getLabels(t)
  const columns = useMemo(
    () => [
      {
        Header: t('common.type', 'Type'),
        Cell: ({ row: { original } }) => {
          return (
            <ValueText type="small" isLocked={isLocked}>
              {LABELS[original?.document_type] ?? '-'}
            </ValueText>
          )
        }
      },
      {
        Header: t('common.status', 'Status'),
        Cell: ({ row: { original } }) => {
          const docType = original?.tag?.split('_')?.[0]
          const documentType = docType === 'school' ? 'employment' : docType
          const documentStatus = path(
            ['trust_score', 'trustworthiness', documentType, 'details', 0, 'status'],
            application
          )
          return <DocumentStatusComponent status={documentStatus} isLocked={isLocked} />
        }
      },
      {
        Header: t('common.source', 'Source'),
        Cell: ({ row: { original } }) => {
          const docType = original?.tag?.split('_')?.[0]
          const documentType = docType === 'school' ? 'employment' : docType
          const documentStatus = path(
            ['trust_score', 'trustworthiness', documentType, 'details', 0, 'status'],
            application
          )
          const disabled = documentStatus !== 'verified' || original?.deleted === '1'
          return (
            <DocumentView
              onClick={original?.onClick}
              isDisabled={disabled}
              size="small"
              isLocked={isLocked}
              documentStatus={documentStatus}
            />
          )
        }
      }
    ],
    [isLocked, isLoading, applicationLoading]
  )

  return (
    <InformationTable
      data={secureFiles}
      columns={columns}
      hideHeader={isMobile}
      isLoading={isLoading}
    />
  )
}

export default DocumentsView
